import {
  createSelector
} from 'reselect';
import {
  getLayout,
  getAttr,
  getPresets,
  getFabricData,
  getFabricSetToArticles,
  getSkeleton,
  getInStockFabricList,
  getNormalizedContrastTypes
} from './config';
import {
  getActiveDetailsPreset
} from './ui';
import {
  getPartnerState,
} from './users';
import ContrastHierarchy from '../../structs/ContrastHierarchy';
import { makeGetFilter } from './search';

export const getSelectedAttrs = state => state.general.updateProduct.selectedParts;

export const getSelectedButtons = state => state.general.updateProduct.selectedButtons;

export const getSelectedContrasts = state => state.general.updateProduct.selectedContrasts;

export const getSelectedFabric = state => state.general.updateProduct.selectedFabric;

export const getSelectedFabricAttr = createSelector(
  getSelectedFabric,
  (fabric) => Object.values(fabric)[0].article
)

export const getTotalOrdePrice = state => state.general.updatePrice.shirtPrice;

export const getUserMaleSize = state => state.general.updateSize.userMaleSizes;

export const getSizeScenario = state => state.general.updateSize.sizeScenario;

export const getSizesStandart = state => state.general.updateSize.standart;

export const getSizesProfile = state => state.general.updateSize.profile;

export const getSizeStandart = state => state.general.updateSize.sizeStandart;

export const getSelectedContrastType = state => state.general.updateProduct.selectedContrastType;

export const getSelectedContrast = state => state.general.updateProduct.selectedContrastType;

export const getContrastSearchTerms = state => state.general.updateProduct.contrastSearchTerms;

export const getShirtRemarks = createSelector(
  getSelectedAttrs,
  (attrs) => attrs.shirtRemarks || ''
)

export const getSelectedEmbroyderyText = createSelector(
  getSelectedAttrs,
  (attrs) => attrs.embroideryText || ''
)

export const getSelectedEmbroyderyFont = createSelector(
  getSelectedAttrs,
  (attrs) => attrs.embroideryFont && attrs.embroideryFont.attrValue || ''
)

export const getSelectedEmbroyderyColor = createSelector(
  getSelectedAttrs,
  (attrs) => {
    return attrs.embroideryColor && attrs.embroideryColor.objectId || '#000000';
  }
)

export const makeGetFabricValuesBySet = (contrastSets) => (
  createSelector(
    getFabricData,
    getFabricSetToArticles,
    getInStockFabricList,
    getContrastSearchTerms,
    getSelectedFabricAttr,
    (fabrics, setToArticles, inStock, terms, selectedFabric) => {


      const contrastFabricKeys = contrastSets.reduce((acc, item) => (
        [...acc, ...setToArticles[item]]
      ), []);
      const result = [];

      for (let key of contrastFabricKeys) {
        if (key == selectedFabric) {
          continue;
        }
        if (fabrics.hasOwnProperty(key) && inStock.hasOwnProperty(key)) {
          result.push(fabrics[key])
        }
      }

      const filter = makeGetFilter(terms);
      return result.filter(filter)
    }
  )
)

export const makeGetFabricValuesBySetWithSearch = (contrastSets) => (
  createSelector(
    makeGetFabricValuesBySet,
    getFabricSetToArticles,
    getInStockFabricList,
    (fabrics, setToArticles, inStock) => {


      const contrastFabricKeys = contrastSets.reduce((acc, item) => (
        [...acc, ...setToArticles[item]]
      ), [])
      const result = [];


      for (let key of contrastFabricKeys) {
        if (fabrics.hasOwnProperty(key) && inStock.hasOwnProperty(key)) {
          result.push(fabrics[key])
        }
      }
      return result
    }
  )
)

export const getSelectedFabricValues = createSelector(
  getSelectedFabric,
  (fabric) => {
    const values = Object.keys(fabric);
    if (values.length > 0) {
      return fabric[values[0]]
    }
    return {}
  }
)

export const getSizeParams = createSelector(
  getSizeScenario,
  getSizesStandart,
  getUserMaleSize,
  getSizesProfile,
  (scenario, standart, measure, proofile) => {
    switch (scenario) {
      case 'standart':
        return standart
      case 'measure':
        return measure;
      case 'profile':
        return proofile;
      default:
        return {}
    }
  }
)

export const getSelectedSize = createSelector(
  getSizeScenario,
  getSizesProfile,
  (scenario, profile) => {
    switch (scenario) {
      case 'standart':
        return {
          displayName: 'Стандартные размеры'
        }
      case 'measure':
        return {
          displayName: 'Таблица размеров'
        }
      case 'smart':
        return {
          displayName: 'Умные мерки'
        }
      case 'profile':
        return {
          displayName: `Профиль «${profile.displayName}»`
        }
      default:
        return null
    }
  }
)

export const getSizeSmart = state => state.general.updateSize.sizeSmart;

export const getSelectedAttr = state => state.general.updateProduct.selectedAttr;


const getContrastsDict = () => {
  const contrastHierarchy = new ContrastHierarchy()
  return contrastHierarchy.getDict();
}


export const getContrastHierarchy = createSelector(
  getSelectedAttr,
  getContrastsDict,
  (selectedAttr, dict) => {
    return {
      ...dict[selectedAttr.attrName],
      value: selectedAttr.attrValue
    }
  }
)

const getFabricValuesByKeys = (set, fabricData) => {
  return Object.values(fabricData).filter(fabirc => {
    return set.indexOf(fabirc.article) > -1
  })
}


export const getAttrDataValueEnums = createSelector(
  getAttr,
  getSelectedAttr,
  getSkeleton,
  (layout, attr, skeleton) => {
    const {
      enums
    } = layout
    const {
      attrName,
      attrValue
    } = attr


    if (!enums.hasOwnProperty(attrName)) {
      return attr.attrValue
    }

    if (typeof attrValue === 'object') {
      const key = attrValue.attrValue
      return enums[attrName].values[key]
    }

    if (
      typeof attrValue === 'string' ||
      typeof attrValue === 'boolean'
    ) {
      let val = enums[attrName].values[attrValue];
      if(val !== undefined) {
        return val;
      } else {
        console.info(`%cvalue (${attrValue}) not found for (${attrName})`, 'color: magenta;')
        if(skeleton.hasOwnProperty(attrName)) {
          const attr = skeleton[attrName];
          val = enums[attrName].values[attr];
          if(val !== undefined) {
            return val;
          }
        }
      }
    }

    return {}
  }
)

export const checkAttrDataValueEnums = (attrValue, attrName) => (
  createSelector(
    getAttr,
    (layout) => {
      const { enums } = layout;

      if (!enums.hasOwnProperty(attrName)) {
        return true;
      }

      if (typeof attrValue === 'object') {
        const key = attrValue.attrValue
        return enums[attrName].values[key] ? true : false;
      }

      if (
        typeof attrValue === 'string' ||
        typeof attrValue === 'boolean'
      ) {
        let val = enums[attrName].values[attrValue];
        return val !== undefined ? true : false;
      }
      return false;
    }
  )
)

export const getAttrDataValueContrasts = createSelector(
  getFabricData,
  getContrastHierarchy,
  getNormalizedContrastTypes,
  (fabricData, contrastHierarchy, contrasts) => {
    return {
      ...contrastHierarchy,
      ...fabricData[contrastHierarchy.value],
      ...contrasts[contrastHierarchy.contrastKey],
    }
  }
)

export const getAttrDataValueButtons = createSelector(
  getAttr,
  getSelectedAttr,
  (layout, attr) => {
    const {
      buttons: { buttons: { values } }
    } = layout
    const {
      attrValue
    } = attr
    if (values.hasOwnProperty(attrValue)) {
      return {
        [attrValue]: values[attrValue]
      }
    }
    return {}
  }
)

export const getAttrDataValueFabrics = createSelector(
  getFabricData,
  getSelectedAttr,
  (fabricData, attr) => {
    const {
      attrValue
    } = attr
    if (fabricData.hasOwnProperty(attrValue)) {
      return {
        [attrValue]: fabricData[attrValue]
      }
    }
    return {}
  }
)

export const prepareOrderSceleton = createSelector(
  getSelectedAttrs,
  getAttr,
  getTotalOrdePrice,
  (selectedParts, attr, price) => {
    return Object.keys(attr.enums).reduce((acc, enumKey) => ({
      ...acc,
      [enumKey]: selectedParts.hasOwnProperty(enumKey) ? selectedParts[enumKey] : ''
    }), {
      price
    })
  }
)



export const prepareOrderSceletonWithDefaults = createSelector(
  getSelectedAttrs,
  getSkeleton,
  (parts, skeleton) => {
    const result = {}
    for (let key in skeleton) {
      result[key] = parts.hasOwnProperty(key) ? parts[key].attrValue : skeleton[key];
      if (key === 'shirtRemarks' || key === 'embroideryText') {
        result[key] = parts.hasOwnProperty(key) ? parts[key] : skeleton[key];
      }
      if (key === 'embroideryVariant') {
        result[key] = parts.hasOwnProperty('embroidery') ? 'embroideryMonogram' : skeleton[key];
      }
    }
    return result
  }
)

export const getLayoutAttr = createSelector(
  getLayout,
  getAttr,
  (state, sectionName) => (sectionName),
  (layout, attr, sectionName) => {
    const section = layout.sections[sectionName];
    for (let key in section.enums) {
      const s = section.enums[key];
      if (!s.inlineValue) {
        section.enums[key] = {
          ...section.enums[key],
          ...mergeAttribute(key, attr)
        }
      }
    }
    return section;
  }
);

export const mergeAttribute = (key, attr) => {
  let result = {}
  switch (key) {
    case 'buttons': {
      return attr.buttons.buttons
    }
    default: {
      if (attr.enums.hasOwnProperty(key)) {
        return attr.enums[key];
      }
    }
  }
  return result;
}


const getAttrValuesByKey = (key, attr) => {
  let result = {}
  switch (key) {
    case 'buttons': {
      return attr.buttons.buttons.values
    }
    default: {
      if (attr.enums.hasOwnProperty(key)) {
        return attr.enums[key].values;
      }
    }
  }
  return result;
}


/* contrasts functions */

const getFabricBySetType = (set, setToArticles) => {
  return Object.keys(setToArticles).reduce((acc, item) => {
    return set.indexOf(item) > -1 ? [...acc, ...setToArticles[item]] : acc
  }, [])
}

const convertToLayerValue = values => {
  let result = {}
  values.forEach(e => {
    let attrValue = e.article
    result = {
      ...result,
      [e.article]: {
        ...e,
        attrValue
      }
    }
  })
  return result
}

const getContrastsValues = (key, layout, sets, data) => {
  const fabricSets = layout.sections.contrast.enums[key].fabricSet;
  const fabricArticles = getFabricBySetType(fabricSets, sets);
  const fabricValues = getFabricValuesByKeys(fabricArticles, data);
  return convertToLayerValue(fabricValues)
}


export const getSelectedPresetDetails = createSelector(
  getPresets,
  getLayout,
  getAttr,
  getActiveDetailsPreset,
  getSelectedAttrs,
  getFabricSetToArticles,
  getFabricData,
  (
    presets,
    layout,
    attr,
    activePreset,
    selectedParts,
    fabricSets,
    fabricData
  ) => {
    if (activePreset) {
      const presetValues = presets[activePreset].values;
      const result = {};
      for (let key in presetValues) {
        const pv = presetValues[key]
        if (key === 'collarFabric') {
          result[key] = getContrastsValues('collar', layout, fabricSets, fabricData)[pv]
        } else {
          result[key] = getAttrValuesByKey(key, attr)[pv]
        }
      }
      return result;
    }
    return selectedParts;
  }
)



export const getTotalPrice = createSelector(
  getPartnerState,
  getTotalOrdePrice,
  (isPartner, {
    price,
    discount
  }) => {
    return isPartner ? (price - discount) : price
  }
)

export const getAttrPrice = createSelector(
  getSelectedAttrs,
  (parts) => {
    return Object.values(parts).reduce(
      (acc, item) => ({
        ...acc,
        price: (acc.price || 0) + (item.price || 0),
        discount: (acc.discount || 0) + (item.discount || 0),
      }), {
      price: 0,
      discount: 0
    }
    )
  }
)


export const getFabricPrice = createSelector(
  getSelectedAttr,
  getSelectedFabric,
  (attr, fabric) => {
    const {
      price,
      discount
    } = fabric[attr.attrValue];
    return {
      price,
      discount
    }
  }
)



export const getContrastPrice = createSelector(
  getSelectedContrasts,
  getNormalizedContrastTypes,
  (contrasts, contrastEnums) => {

    const data = Object.values(contrasts).reduce((acc, item) => ({
      price: acc.price + contrastEnums[item.contrastKey].price,
      discount: acc.discount + contrastEnums[item.contrastKey].discount,
    }), {
      price: 0,
      discount: 0
    });

    return data
  }
)


export const recalculateShirtPrice = createSelector(
  getSelectedAttrs,
  getSelectedFabric,
  getSelectedContrasts,
  getSelectedButtons,
  getPartnerState,
  (
    attrs,
    fabric,
    contrasts,
    buttons,
    isPartner
  ) => {

    const agregate = (data) =>
      Object.values(data)
        .reduce((acc, item) => ({
          price: item.price ? parseFloat(acc.price) + parseFloat(item.price) : parseFloat(acc.price),
          discount: item.discount ? parseFloat(acc.discount) + parseFloat(item.discount) : parseFloat(acc.discount),
        }), {
          price: 0,
          discount: 0
        })


    const sanitaze = ({
      price,
      discount
    }) => ({
      price: isNaN(price) ? 0 : price,
      discount: isNaN(discount) ? 0 : discount,
    })

    const prices = {
      fabric: agregate(fabric),
      attrs: agregate(attrs),
      buttons: agregate(buttons),
      contrasts: agregate(contrasts),
    };

    const {
      price,
      discount
    } = sanitaze(agregate(prices));


    return isPartner ? (price - discount) : price
  }
)

export const calcPresetsAttrsPrices = createSelector(
  getAttr,
  getPresets,
  (
    attrs,
    presets
  ) => {
    let prices = {}
    Object.values(presets).forEach(preset => {
      const presetId = preset.id;
      let result = {};
      const presetValues = preset.values;
      for (let key in presetValues) {
        const pv = presetValues[key];
        const presetValue = getAttrValuesByKey(key, attrs)[pv];

        if (presetValue) {
          prices[presetId] = prices[presetId] === undefined ? 0 : prices[presetId] + Number(presetValue.price);
          result[key] = presetValue;
        }
      }
    })
    return prices;
  }
)